import { render } from "./Print3DOrdenesPage.vue?vue&type=template&id=02880dea&scoped=true"
import script from "./Print3DOrdenesPage.vue?vue&type=script&lang=js"
export * from "./Print3DOrdenesPage.vue?vue&type=script&lang=js"

import "./Print3DOrdenesPage.vue?vue&type=style&index=0&id=02880dea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02880dea"]])

export default __exports__